import React, { useEffect, useRef, useState, useContext } from "react";
import Footer12 from "../shared/Footer12";
import Navbar12 from "../shared/Navbar12";
import Sidebar12 from "../shared/Sidebar12";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import Swal from "sweetalert2";
import { ContextBoard } from "../../context/ContextBoard";

function CorrectStudent12() {
  const { setClass12regulardata } = useContext(ContextBoard);
  const navigate = useNavigate();
  let candidateid;
  let category;

  // ---------------- REGISTRATION NUMBER FIELDS ----------------
  const [reg1, setReg1] = useState("");
  const [reg2, setReg2] = useState("");
  const [reg3, setReg3] = useState("");
  const [regno, setRegno] = useState("");

  const [loading, setLoading] = useState(false);

  // Refs for auto-focus
  const reg1Ref = useRef();
  const reg2Ref = useRef();
  const reg3Ref = useRef();

  // ---------------- ROLL FIELDS ----------------
  const [rollCode, setRollCode] = useState("");
  const [rollNo, setRollNo] = useState("");

  // ---------------- HELPERS ----------------
  const allowDigits = (value) => value.replace(/\D/g, "");

  // Disable logic
  const isRegFilled = reg1 || reg2 || reg3;
  const isRollFilled = rollCode || rollNo;

  // -------- Registration field change handler --------
  const handleRegChange = (setter, value, max, nextRef) => {
    const v = allowDigits(value).slice(0, max);
    setter(v);

    if (v.length === max && nextRef?.current) {
      nextRef.current.focus();
    }
  };

  // -------- Backspace auto-focus previous --------
  const handleBackspace = (e, value, prevRef) => {
    if (e.key === "Backspace" && value.length === 0 && prevRef?.current) {
      prevRef.current.focus();
    }
  };
  useEffect(() => {
    setClass12regulardata("");
  }, [navigate]);
  const handleLoginWithCaptcha = async () => {
    // If user started entering Registration Number (any of reg1, reg2, reg3)
    const isRegEntered = reg1 || reg2 || reg3;

    // If user started entering Roll details
    const isRollEntered = rollCode || rollNo;

    // ------------------- VALIDATION -------------------
    if (isRegEntered) {
      // Validate Registration fields only
      if (!reg1 || !reg2 || !reg3 || !regno) {
        Swal.fire(
          "Warning",
          "Please enter complete registration number",
          "warning"
        );
        return;
      }
    } else if (isRollEntered) {
      // Validate Roll fields only
      if (!rollCode) {
        Swal.fire("Warning", "Please enter roll code", "warning");
        return;
      }
      if (!rollNo) {
        Swal.fire("Warning", "Please enter roll number", "warning");
        return;
      }
    } else {
      // If NOTHING entered
      Swal.fire(
        "Warning",
        "Please enter either registration number or roll number",
        "warning"
      );
      return;
    }

    await handleLogin();
  };
  const referenceNo =
    reg1 && regno && reg2 && reg3 ? `${reg1}-${regno}-${reg2}-${reg3}` : null;
  const handleLogin = async () => {
    setLoading(true);
    const token = sessionStorage.getItem("tokenclassxii");
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/SchoolForCorrectionPortal_CL12`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },

          body: JSON.stringify({
            refferencE_NO: referenceNo,
            rolL_NO: rollNo ? rollNo : null,
          }),
        }
      );

      const data = await response.json();
      // console.log("Login response:", data);
      if (response.ok) {
        console.log("Login response:", data);
        candidateid = data.data.candidatE_ID;
        category = data.data.studenT_EXAM_CATEGORY_DESCRIPTION;
        if (category === "EX-REGULAR") {
          // navigate(`/class-x-add-ex-regular-student`);
          try {
            const response = await fetch(
              `${config.API_BASE_URL}/GetStudentByCandidateIdForEdit_CL12`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                  candidatE_ID: candidateid,
                }),
              }
            );

            const result = await response.json();

            if (!response.ok || result.status === 404) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.message || "Something went wrong",
              });
              return;
            }
            navigate("/class-xii-correction-exregular", {
              state: { studentData: result.data.editStudent_data },
            });
          } catch (error) {
            console.error("Error fetching data:", error.message);

            Swal.fire({
              icon: "error",
              title: "Error",
              text: error.message || "Failed to fetch data",
            });
          }
        } else if (category === "BETTERMENT") {
          try {
            const response = await fetch(
              `${config.API_BASE_URL}/GetStudentByCandidateIdForEditBetterment_CL12`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                  candidatE_ID: candidateid,
                }),
              }
            );

            const result = await response.json();

            if (!response.ok || result.status === 404) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.message || "Something went wrong",
              });
              return;
            }
            navigate("/class-xii-correction-betterment", {
              state: { studentData: result.data },
            });
          } catch (error) {
            console.error("Error fetching data:", error.message);

            Swal.fire({
              icon: "error",
              title: "Error",
              text: error.message || "Failed to fetch data",
            });
          }
        } else if (category === "QUALIFYING") {
          try {
            const response = await fetch(
              `${config.API_BASE_URL}/GetStudentByCandidateIdForEditQualifying_CL12`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                  candidatE_ID: candidateid,
                }),
              }
            );

            const result = await response.json();

            if (!response.ok || result.status === 404) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.message || "Something went wrong",
              });
              return;
            }
            navigate("/class-xii-correction-qualify", {
              state: { studentData: result.data },
            });
          } catch (error) {
            console.error("Error fetching data:", error.message);

            Swal.fire({
              icon: "error",
              title: "Error",
              text: error.message || "Failed to fetch data",
            });
          }
        } else {
          try {
            const response = await fetch(
              `${config.API_BASE_URL}/GetStudentByCandidateIdForEdit_CL12`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                  candidatE_ID: candidateid,
                }),
              }
            );

            const result = await response.json();

            if (!response.ok || result.status === 404) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: result.message || "Something went wrong",
              });
              return;
            }

            setClass12regulardata(true);

            navigate("/class-xii-correction-regular", {
              state: { candidateData: result.data.editStudent_data },
            });
          } catch (error) {
            console.error("Error fetching data:", error.message);

            Swal.fire({
              icon: "error",
              title: "Error",
              text: error.message || "Failed to fetch data",
            });
          }
        }
      } else {
        Swal.fire(
          "Error",
          data?.message || "Invalid login credentials",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong. Try again later.", "error");
      console.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div className="container-scroller">
        <Navbar12 />

        <div className="container-fluid page-body-wrapper">
          <Sidebar12 />

          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-md-12 mb-1">
                  <section className="content-header">
                    <h1>
                      <i className="fa fa-user"></i>&nbsp;Correct Student Data{" "}
                      <span className="text-danger">
                        ( Correction applicable for only challan generated
                        students )
                      </span>
                    </h1>

                    <ol className="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/class-xii-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li className="active">Correct Student Data</li>
                    </ol>
                  </section>
                </div>
              </div>

              {/* ---------------- SEARCH CARD ---------------- */}
              <div className="row">
                <div className="card">
                  <div className="card-body">
                    <div className="row align-items-end">
                      {/* ---------------- REGISTRATION NO ---------------- */}
                      <div className="col-md-4">
                        <label className="mb-2">
                          {" "}
                          Please Enter Registration No:-
                        </label>
                        <div style={{ display: "flex", gap: "5px" }}>
                          {/* 5-digit PART 1 */}
                          <input
                            ref={reg1Ref}
                            type="text"
                            maxLength={5}
                            disabled={isRollFilled}
                            value={reg1}
                            onChange={(e) =>
                              handleRegChange(
                                setReg1,
                                e.target.value,
                                5,
                                reg2Ref
                              )
                            }
                            onKeyDown={(e) => handleBackspace(e, reg1, null)}
                            placeholder="5 digits"
                            className="form-control form-control-xs"
                          />
                          <div>-</div>
                          <select
                            disabled={isRollFilled}
                            id="registration_number4"
                            name="registration_number4"
                            className="form-control form-select form-control-xs"
                            onChange={(e) => {
                              setRegno(e.target.value);
                            }}
                            value={regno}
                          >
                            <option value="">Select</option>
                            <option value="RS">RS</option>
                            <option value="RC">RC</option>
                            <option value="RA">RA</option>
                            <option value="PC">PC</option>
                            <option value="PA">PA</option>
                          </select>
                          <div>-</div>

                          {/* 5-digit PART 2 */}
                          <input
                            ref={reg2Ref}
                            type="text"
                            maxLength={4}
                            disabled={isRollFilled}
                            value={reg2}
                            onChange={(e) =>
                              handleRegChange(
                                setReg2,
                                e.target.value,
                                4,
                                reg3Ref
                              )
                            }
                            onKeyDown={(e) => handleBackspace(e, reg2, reg1Ref)}
                            placeholder="4 digits"
                            className="form-control form-control-xs"
                          />

                          <div>-</div>

                          {/* 2-digit PART 3 */}
                          <input
                            ref={reg3Ref}
                            type="text"
                            maxLength={2}
                            disabled={isRollFilled}
                            value={reg3}
                            onChange={(e) =>
                              handleRegChange(setReg3, e.target.value, 2, null)
                            }
                            onKeyDown={(e) => handleBackspace(e, reg3, reg2Ref)}
                            placeholder="2 digits"
                            className="form-control form-control-xs"
                          />
                        </div>
                      </div>

                      <div
                        className="col-md-1 text-center text-danger"
                        style={{
                          height: "28px",
                          fontWeight: "600",
                          display: "none",
                        }}
                      >
                        Or
                      </div>

                      {/* ---------------- ROLL CODE ---------------- */}
                      <div className="col-md-2" style={{ display: "none" }}>
                        <label className="mb-2">Roll Code :</label>
                        <input
                          type="text"
                          maxLength={5}
                          disabled={isRegFilled || regno}
                          value={rollCode}
                          onChange={(e) =>
                            setRollCode(allowDigits(e.target.value).slice(0, 5))
                          }
                          className="form-control form-control-xs"
                          placeholder="5 digits"
                        />
                      </div>

                      {/* ---------------- ROLL NUMBER ---------------- */}
                      <div className="col-md-2" style={{ display: "none" }}>
                        <label className="mb-2">Roll Number :</label>
                        <input
                          type="text"
                          maxLength={5}
                          disabled={isRegFilled || regno}
                          value={rollNo}
                          onChange={(e) =>
                            setRollNo(allowDigits(e.target.value).slice(0, 5))
                          }
                          className="form-control form-control-xs"
                          placeholder="5 digits"
                        />
                      </div>

                      {/* ---------------- SEARCH BUTTON ---------------- */}
                      <div className="col-md-1">
                        <button
                          className="btn btn-success"
                          onClick={handleLoginWithCaptcha}
                        >
                          <i className="fa fa-search"></i>&nbsp;Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer12 />
          </div>
        </div>
      </div>
    </>
  );
}

export default CorrectStudent12;
